<template>
  <div class="col-9 ms-auto me-5 px-3">
		<div class="col-12 d-flex justify-content-between align-items-end p-0 my-4">
			<div class="body-title mt-3">Desglose de efectivo</div>
		</div>

		<div class="content-view col-12">
			<form class="col-12 row px-5 mx-0 mt-4" @submit.prevent="openCashRegisterConf()">
				<!-- Form Header -->
				<div class="col-12 d-flex justify-content-between">
					<div class="col-6">
						<label class="fw-bold">Monto de apertura:</label>
						<div class="col-8">
							<div class="form-group col-10 mb-4">
								<CurrencyInput
									@keydown.enter="enterAsTab"
									type="text"
									class="form-control text-center"
									v-model="cashRegister.opening" required>
								</CurrencyInput>
							</div>
						</div>
					</div>

					<div>
						<div class="col-12 text-center">
							<button type="submit" class="btn btn-lg btn-success" :disabled="cashRegister.opening <= 0">Abrir caja</button>
						</div>
					</div>
				</div>
				<!-- Form Body -->
				<div class="d-flex justify-content-between">
					<!-- Monedas container -->
					<div class="col-5 row">
						<h5 class="fw-bold">Monedas:</h5>
						<!-- fila 1 -->
						<div class="row">
							<!-- Monedas de 1 -->
							<div class="col-6 pe-0">
								<div class="input-group mb-3">
									<span class="input-group-text fw-bold" id="basic-addon1">RD$ 1</span>
										<CurrencyInput
											@keydown.enter="enterAsTab"
											type="text"
											class="form-control"
											placeholder="Qty"
											v-model="cashRegister.coin_1" required>
										</CurrencyInput>
								</div>
							</div>
							<!-- Monedas de 5 -->
							<div class="col-6 pe-0">
								<div class="input-group mb-3">
									<span class="input-group-text fw-bold" id="basic-addon1">RD$ 5</span>
									<CurrencyInput
										@keydown.enter="enterAsTab"
										type="text"
										class="form-control"
										placeholder="Qty"
										v-model="cashRegister.coin_5" required>
									</CurrencyInput>
								</div>
							</div>
						</div>

						<!-- fila 2 -->
						<div class="row">
							<!-- Monedas de 10 -->
							<div class="col-6 pe-0">
								<div class="input-group mb-3">
									<span class="input-group-text fw-bold" id="basic-addon1">RD$ 10</span>
									<CurrencyInput
										@keydown.enter="enterAsTab"
										type="text"
										class="form-control"
										placeholder="Qty"
										v-model="cashRegister.coin_10" required>
									</CurrencyInput>
								</div>
							</div>
							<!-- Monedas de 25 -->
							<div class="col-6 pe-0">
								<div class="input-group mb-3">
									<span class="input-group-text fw-bold" id="basic-addon1">RD$ 25</span>
									<CurrencyInput
										@keydown.enter="enterAsTab"
										type="text"
										class="form-control"
										placeholder="Qty"
										v-model="cashRegister.coin_25" required>
									</CurrencyInput>
								</div>
							</div>
						</div>

						<div class="d-flex">
							<h5 class="fw-bold">Total de monedas:</h5>
							<span class="ps-1">RD$ {{ totalCoinsAmount }}</span>
						</div>
					</div>

					<!-- Billetes Container -->
					<div class="col-7 d-flex flex-column">
						<h5 class="fw-bold ms-4">Billetes:</h5>
						<div class="d-flex flex-column align-items-end">
							<!-- Fila de billetes -->
							<div class="col-12 row">
								<!-- Billetes de 50 -->
								<div class="col-4 pe-0">
									<div class="input-group mb-3">
										<span class="input-group-text fw-bold" id="basic-addon1">RD$ 50</span>
										<CurrencyInput
										@keydown.enter="enterAsTab"
										type="text"
										class="form-control"
										placeholder="Qty"
										v-model="cashRegister.bill_50" required>
									</CurrencyInput>
									</div>
								</div>
								<!-- Billetes de 100 -->
								<div class="col-4 pe-0">
									<div class="input-group mb-3">
										<span class="input-group-text fw-bold" id="basic-addon1">RD$ 100</span>
										<CurrencyInput
										@keydown.enter="enterAsTab"
										type="text"
										class="form-control"
										placeholder="Qty"
										v-model="cashRegister.bill_100" required>
									</CurrencyInput>
									</div>
								</div>
								<!-- Billetes de 200 -->
								<div class="col-4 pe-0">
									<div class="input-group mb-3">
										<span class="input-group-text fw-bold" id="basic-addon1">RD$ 200</span>
										<CurrencyInput
										@keydown.enter="enterAsTab"
										type="text"
										class="form-control"
										placeholder="Qty"
										v-model="cashRegister.bill_200" required>
									</CurrencyInput>
									</div>
								</div>
							</div>

							<!-- Fila de billetes -->
							<div class="col-12 row">
								<!-- Billetes de 500 -->
								<div class="col-4 pe-0">
									<div class="input-group mb-3">
										<span class="input-group-text fw-bold" id="basic-addon1">RD$ 500</span>
										<CurrencyInput
										@keydown.enter="enterAsTab"
										type="text"
										class="form-control"
										placeholder="Qty"
										v-model="cashRegister.bill_500" required>
									</CurrencyInput>
									</div>
								</div>
								<!-- Billetes de 1000 -->
								<div class="col-4 pe-0">
									<div class="input-group mb-3">
										<span class="input-group-text fw-bold" id="basic-addon1">RD$ 1000</span>
										<CurrencyInput
										@keydown.enter="enterAsTab"
										type="text"
										class="form-control"
										placeholder="Qty"
										v-model="cashRegister.bill_1000" required>
									</CurrencyInput>
									</div>
								</div>
								<!-- Billetes de 2000 -->
								<div class="col-4 pe-0">
									<div class="input-group mb-3">
										<span class="input-group-text fw-bold" id="basic-addon1">RD$ 2000</span>
										<CurrencyInput
										@keydown.enter="enterAsTab"
										type="text"
										class="form-control"
										placeholder="Qty"
										v-model="cashRegister.bill_2000" required>
									</CurrencyInput>
									</div>
								</div>
							</div>

							<div class="d-flex">
								<h5 class="fw-bold">Total de billetes:</h5>
								<span class="ps-1">RD$ {{ totalBillsAmount }}</span>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
  </div>
</template>

<script>
import CurrencyInput from './CurrencyInputComponent.vue';

export default {
	components: {
		CurrencyInput,
	},
	data(){
		return {
			cashRegister  :   {
				opening     :   '',
				total_cash  :   '0',

				/* Monedas */
				coin_1		  : "0.00",
				coin_5		  : "0.00",
				coin_10		  : "0.00",
				coin_25		  : "0.00",

				/* Billetes */
				bill_50		  : "0.00",
				bill_100	  : "0.00",
				bill_200	  : "0.00",
				bill_500	  : "0.00",
				bill_1000	  : "0.00",
				bill_2000	  : "0.00",
			},
		}
	},
	computed:{
		/**
		 * Calculate the total amout of coins
		 * @return int
		 */
		totalCoinsAmount(){
			return (
				+this.cashRegister.coin_1 			 +
				(this.cashRegister.coin_5  * 5)  +
				(this.cashRegister.coin_10 * 10) +
				(this.cashRegister.coin_25 * 25)
			).toFixed(2)
		},
		/**
		 * Calculate the total amout of coins
		 * @return int
		 */
		totalBillsAmount(){
			return (
				(+this.cashRegister.bill_50  * 50)   +
				(this.cashRegister.bill_100  * 100)  +
				(this.cashRegister.bill_200  * 200)  +
				(this.cashRegister.bill_500  * 500)  +
				(this.cashRegister.bill_1000 * 1000) +
				(this.cashRegister.bill_2000 * 2000)
			).toFixed(2)
		}
	},
	methods : {
		/**
		 *  Send data to backend and Open a new CashRegister
		 */
		openCashRegister(){
			this.cashRegister.total_coins = this.totalCoinsAmount;
			this.cashRegister.total_bills = this.totalBillsAmount;
			axios.post('/cashregister', this.cashRegister)
			.then((res) => {
				if(res.data.success){
					window.location.href = "/invoice";
				}
			})
			.finally(res => {
				console.log(res)
			})
		},

		/* Message modal with confirmation message */
		openCashRegisterConf(){
			let canOpen = (+this.totalCoinsAmount + +this.totalBillsAmount) == this.cashRegister.opening;
			console.log(canOpen);
			if(!canOpen){
				Swal.fire({
					icon  : "error",
					title : "Error en Desglose",
					html  : `El desglose de efectivo no es igual al monto de apertura. </br>
									El monto de apertura ingresado es de <strong>${this.formatNumber(this.cashRegister.opening)}</strong>,
									mientras que el desglose de efectivo es de
									<strong> ${this.formatNumber(+this.totalCoinsAmount + +this.totalBillsAmount)}<strong>`,

					confirmButtonText : 'Confirmar',
					denyButtonText	  : 'Cancelar',
				});
			}else{
				Swal.fire({
					icon  : "warning",
					title  : "¿Deseas abrir la caja?",
					showCancelButton : true,
					confirmButtonText : 'Confirmar',
					denyButtonText	  : 'Cancelar',
				}).then(result => {
					if(result.isConfirmed) {
						this.openCashRegister();
					}
				});
			}
		}
	},
}
</script>

<style>

</style>
